// extracted by mini-css-extract-plugin
export default {"warning-button-icon":"warning-button-icon_rkwXjtqL"};